export const defaultSelectedStock={
    nasdaq:"TSLA",
    name:"Tesla"
}